import csvIcon from '@/assets/csv.svg';

export const CsvIcon = () => <img src={csvIcon} alt="Csv Icon" className="w-4 h-4 mr-2" />;
